import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { ButtonTypes } from "../../models/shared/button/buttonTypes";
import { theme } from "../../../styles/theme";
import { PrimaryButton } from "../styled/button/styledButtonPrimary.component";

const backgroundColor = "#141D27";
const textColor = theme.palette.text.primary;

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: backgroundColor,
  border: "2px solid #000",
  boxShadow: 24,
  color: textColor,
  p: 4,
};

interface YesModalProps {
  isOpen: boolean;
  actionType: string;
  onButtonClick: (actionType: string, buttonType: string) => void;
  message: string;
  timer: number | undefined;
}

export function YesModal({
  isOpen,
  actionType,
  onButtonClick,
  message,
  timer
}: YesModalProps) {

  const { t } = useTranslation();

  return (
    <div>
      <Modal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{color: textColor, whiteSpace: "pre-line"}}>
            {message}
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <PrimaryButton onClick={() => onButtonClick(actionType, ButtonTypes.Yes)}>{ t("routes.general.yes")}{timer != null ? " (" + timer + ") " : ""}</PrimaryButton>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export {};